/* pages/Categories.jsx */
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Spin, Select, Empty } from "antd";
import "./../style/category.css"

const Categories = () => {
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState(""); // filters the grid while typing
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(
          "https://biz.dropyourbusiness.com/api/categories"
        );
        setCats(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error("Error loading categories", e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const options = useMemo(
    () =>
      cats.map((c) => ({
        label: c.Category_Name,
        value: String(c.Category_Id),
      })),
    [cats]
  );

  const filtered = useMemo(() => {
    if (!q) return cats;
    const needle = q.toLowerCase();
    return cats.filter((c) => c.Category_Name?.toLowerCase().includes(needle));
  }, [q, cats]);

  const go = (c) => navigate(`/category/${c.Category_Id}`, { state: { categoryName: c.Category_Name } });

  return (
    <div className="cat-page">
      {/* HERO */}
      <section className="cat-hero">
        <div className="cat-hero-inner">
          <h1>Category</h1>
          <div className="cat-search-wrap">
            <Select
              showSearch
              allowClear
              placeholder="Search With Category"
              size="large"
              style={{ width: "100%" }}
              options={options}
              optionFilterProp="label"
              onSearch={(text) => setQ(text)}
              onChange={(val) => {
                if (!val) return setQ("");
                const sel = cats.find((c) => String(c.Category_Id) === String(val));
                if (sel) go(sel);
              }}
              filterSort={(a, b) => (a?.label || "").localeCompare(b?.label || "")}
            />
            <button className="cat-search-btn" aria-label="Search">
              {/* magnifier icon */}
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2"/>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* GRID */}
      <section className="cat-grid-sec">
        <Spin spinning={loading} tip="Loading…">
          {!loading && filtered.length === 0 ? (
            <Empty description="No categories found" />
          ) : (
            <div className="cat-grid">
              {filtered.map((c) => {
                const img = c.Category_Image_Url || c.category_image_url;
                return (
                  <article
                    key={c.Category_Id}
                    className="cat-card"
                    role="button"
                    tabIndex={0}
                    onClick={() => go(c)}
                    onKeyDown={(e) => e.key === "Enter" && go(c)}
                  >
                    <div className="cat-card-head">
                      <h3 className="cat-title">{c.Category_Name}</h3>
                      <div className="cat-icon">
                        {img ? (
                          <img
                            src={img}
                            alt={c.Category_Name}
                            onError={(e) => {
                              e.currentTarget.src =
                                "https://via.placeholder.com/64?text=%F0%9F%93%8C";
                            }}
                          />
                        ) : (
                          <div className="cat-icon-ph">🗂️</div>
                        )}
                      </div>
                    </div>

                    <div className="cat-card-foot">
                      <span className="view-link">View all</span>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </Spin>
      </section>

    </div>
  );
};

export default Categories;
